export const ACTIONS = {
  CONFIG: {
    GET_CONFIG: 'GET_CONFIG',
  },
  CUSTOMER: {
    REGISTER_CUSTOMER: 'REGISTER_CUSTOMER',
    REGISTER_CUSTOMER_DATA: 'REGISTER_CUSTOMER_DATA',
    REGISTER_CUSTOMER_CLOSED: 'REGISTER_CUSTOMER_CLOSED',
    UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
    UPDATE_CUSTOMER_CLOSED: 'UPDATE_CUSTOMER_CLOSED',
    UPDATE_CUSTOMER_DATA: 'UPDATE_CUSTOMER_DATA',
    UPDATE_CUSTOMER_SUCCESSFUL: 'UPDATE_CUSTOMER_SUCCESSFUL',
    UPDATE_CUSTOMER_FAILED: 'UPDATE_CUSTOMER_FAILED',
    GET_CUSTOMER_EMAIL: 'GET_CUSTOMER_EMAIL',
    CUSTOMER_EMAIL_INPUT: 'CUSTOMER_EMAIL_INPUT',
    GET_CUSTOMER_PHONE: 'GET_CUSTOMER_PHONE',
    CUSTOMER_PHONE_INPUT: 'CUSTOMER_PHONE_INPUT',
    GET_CUSTOMER_CODE: 'GET_CUSTOMER_CODE',
    CUSTOMER_CODE_INPUT: 'CUSTOMER_CODE_INPUT',
    REGISTER_CUSTOMER_SUCCESS: 'REGISTER_CUSTOMER_SUCCESSFUL',
    REGISTER_CUSTOMER_FAILED: 'REGISTER_CUSTOMER_FAILED',
  },
  PURCHASE: {
    COMPLETE_PURCHASE: 'COMPLETE_PURCHASE',
    PURCHASE_INACTIVITY_TIMEOUT: 'PURCHASE_INACTIVITY_TIMEOUT',
    PURCHASE_UPSELL_PRODUCTS: 'PURCHASE_UPSELL_PRODUCTS',
  },
  COUPON: {
    ENTERED_COUPON_CODE: 'ENTERED_COUPON_CODE',
    ENTER_COUPON_CODE: 'ENTER_COUPON_CODE',
    COUPON_CODE_FAILED: 'COUPON_CODE_FAILED',
  },
  SALE: {
    FINISHED: 'FINISHED',
    START_NEW: 'START_NEW',
  },
  MISC: {
    ADD_DONATION: 'ADD_DONATION',
    GET_TIP: 'GET_TIP',
    ADD_TIP: 'ADD_TIP',
    ADDED_TIP: 'ADDED_TIP',
    DECLINED_TIP: 'DECLINED_TIP',
    SHOW_QR: 'SHOW_QR',
    GET_DONATION: 'GET_DONATION',
    HIDE_MISC_CONTENT: 'HIDE_MISC_CONTENT',
    POS_CONNECTED: 'POS_CONNECTED',
  },
} as const;
